import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SelectManagerSplashScreen from '@/components/chat/SelectManagerSplashScreen'
import type { ICounselor } from '@/components/chat/SelectManagerList'
import SelectManagerList from '@/components/chat/SelectManagerList'
import WideButton from '@/components/common/button/WideButton'
import MainTopBar from '@/components/common/bar/MainTopBar'

const counselors: ICounselor[] = [
  {
    id: 'caring',
    name: '다정이',
    character: '🐝',
    description: '언제나 네 편이 되어줄게! 걱정말고 나한테 다 말해봐!',
    quote: '온화한 미소로 그 어떤 투정도 다 받아주는 한없이 착한 큐비! 혼자 공부 왔던 이야기를 마음껏 말해봐시다!',
    details: '혹시 마음에 안 들면, 다른 상담사로 고를 수 있어. 모든 상담사는 너에게 진심이야. 편하게 골라봐!',
    color: 'bg-yellow-400'
  },
  {
    id: 'direct',
    name: '직답이',
    character: '🐝',
    description: '솔직하고 명확한 조언을 해줄게!',
    quote: '직설적이지만 따뜻한 마음을 가진 상담사예요.',
    details: '때로는 직접적인 조언이 필요할 때가 있어요. 함께 문제를 해결해봐요!',
    color: 'bg-gray-400'
  },
  {
    id: 'passionate',
    name: '열정이',
    character: '🐝',
    description: '에너지 넘치는 상담으로 힘을 줄게!',
    quote: '열정적이고 활기찬 상담사예요.',
    details: '긍정적인 에너지로 함께 성장해나가요!',
    color: 'bg-orange-400'
  }
]

export default function SelectManagerPage() {
  const [currentStep, setCurrentStep] = useState(1)
  const [selectedCounselor, setSelectedCounselor] = useState<ICounselor>(counselors[0])
  const navigate = useNavigate()
  useEffect(() => {
    if (currentStep === 1) {
      const timer = setTimeout(() => {
        setCurrentStep(2)
      }, 1500)
      return () => clearTimeout(timer)
    } else if (currentStep === 2) {
      const timer = setTimeout(() => {
        setCurrentStep(3)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [currentStep])

  const handleCounselorSelect = (counselor: ICounselor) => {
    setSelectedCounselor(counselor)
  }

  const handleStartCounseling = () => {
    navigate(
      `/chatRoom?counselor=${selectedCounselor.id}&title=${encodeURIComponent(`${selectedCounselor.name}와의 상담`)}`
    )
  }

  // 첫 번째 스플래시 화면
  if (currentStep === 1) {
    return <SelectManagerSplashScreen stepNumber={1} />
  }

  // 두 번째 스플래시 화면
  if (currentStep === 2) {
    return <SelectManagerSplashScreen stepNumber={2} />
  }

  // 세 번째 화면 - 상담사 선택
  return (
    <div className='min-h-screen flex flex-col'>
      {/* 헤더 */}
      <MainTopBar hasBackButton={true} handleClickBackButton={() => navigate(-1)} />

      {/* 메인 콘텐츠 영역 */}
      <div className='flex-1 px-4 flex flex-col'>
        {/* 상담사 선택 제목 */}
        <div className='text-center mb-6'>
          <h2 className='text-xl font-bold text-amber-900'>상담사를 선택해주세요</h2>
        </div>

        {/* 상담사 목록 */}
        <SelectManagerList
          counselors={counselors}
          selectedCounselor={selectedCounselor}
          handleCounselorSelect={handleCounselorSelect}
        />

        {/* 선택된 상담사 정보 카드 */}
        <div className='bg-white rounded-2xl shadow-lg overflow-hidden mb-4'>
          <div className='p-6'>
            <h3 className='text-xl font-bold text-gray-800 text-center mb-4'>{selectedCounselor.name}</h3>

            <div className='bg-amber-50 rounded-2xl p-4 mb-4 border border-amber-200'>
              <p className='text-sm font-medium text-amber-900 text-center leading-relaxed'>
                "{selectedCounselor.description}"
              </p>
            </div>

            <p className='text-sm text-gray-600 leading-relaxed text-center'>{selectedCounselor.quote}</p>
          </div>
        </div>

        {/* 설명 문구 */}
        <div className='flex-1 flex items-end'>
          <p className='text-xs text-amber-900 leading-relaxed text-center px-4 mb-4 w-full'>
            혹시 마음에 안 들면, 다른 상담사로 고를 수 있어. 모든 상담사는 너에게 진심이야. 편하게 골라봐!
          </p>
        </div>

        {/* 상담 시작 버튼 */}
        <div className='pb-6'>
          <WideButton handleClick={handleStartCounseling} buttonText='상담 시작' />
        </div>
      </div>
    </div>
  )
}
